/**
 * NewApp — the redesigned app layout.
 *
 * Dark theme with purple accent. This is a presentational shell.
 * All business logic (API calls, data hooks) lives in `shared/` — this file
 * contains only layout and visual components.
 */

import React from 'react'
import { RouterProvider } from 'react-router-dom'
import { router } from './Routes/routes'

// ---------------------------------------------------------------------------
// Component
// ---------------------------------------------------------------------------

const NewApp: React.FC = () => {
  return (
    <div data-testid='new-app'>
      <RouterProvider router={router} />
    </div>
  )
}

export default NewApp
